import Banner from '@zenbusiness/zui/Banner';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';

import useBreakpoints from '#client/hooks/useBreakpoints';

export const MissingInfoBanner = () => {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <Stack
      margin={`${isDesktop ? '0px' : '-23px'} auto -46px`}
      width="100%"
    >
      <Banner
        slots={{
          startIcon: (
            <SharedAsset
              alt=""
              src="/icon/micro/alert-fill.svg"
            />
          )
        }}
        subtitle="Please contact customer support to provide the correct information we need to continue."
        title="Your application is missing some info"
        variant="alert"
      />
    </Stack>
  );
};
